import React from "react";
import Select, { components } from 'react-select'
import getMomentDateObj from "../../functions/getMomentDateObj";
import getShowtimeKey from "../../functions/getShowtimeKey";
import getTranslation from "../../functions/getTranslation";
import checkForQuickTicketSelectOptions from "../../functions/checkForQuickTicketSelectOptions";

const BuyTicketMovieShowtimes = ({state, movies, translation, dateNow, moviesOrder, selectSettings, changeMovieShowtime}) => {
    const { timezone } = translation 
    const { currentMovieDate, currentMovieShowtimeOption, currentMovieID, currentCinema } = state
    let options = []
    const showtimeArray = []

    const Placeholder = (props) => {
        return (
          <components.Placeholder {...props}/>
        );
    };

    const onChange = (movie) => {
        if(!movie) {
            const value = ''
            const option = ''
            changeMovieShowtime(value, option)                
        } else {
            const {value} = movie
            const option = movie
            changeMovieShowtime(value, option)
        }
    }

    moviesOrder.map(movieID => {
 
        const currentMoviePerformances = movies[movieID].performances
        currentMoviePerformances.map((performance) => {
            const keyShowtime = getShowtimeKey(performance.timeUtc, timezone)
            const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
            
            if(dateNow.isBefore(performanceDate)) {
                if(performance.limitations.visibleFrom) {
                    const limitationsDate = getMomentDateObj(performance.limitations.visibleFrom, timezone)
                    if(dateNow.isAfter(limitationsDate)) {
                        showtimeArray.push(keyShowtime)
                    }
                } else {
                    showtimeArray.push(keyShowtime)
                }
            }
        })
    })

    let sortedShowtimes = _.uniq(showtimeArray).sort()

    if(currentMovieID !== '') {
        sortedShowtimes = _.filter(sortedShowtimes, showtimeId => {
            const currentMoviePerformances = movies[currentMovieID].performances
            const filteredPerformances = _.filter(currentMoviePerformances, performance => {
                let hasAttribute = checkForQuickTicketSelectOptions(currentMovieDate, showtimeId, currentCinema, performance, dateNow, timezone)
                const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                
                if(!_.contains(hasAttribute, 'false')) {
                    if(performance.limitations.visibleFrom) {
                        const limitationsDate = getMomentDateObj(performance.limitations.visibleFrom, timezone)
                        return dateNow.isAfter(limitationsDate)
                    } else {
                        return dateNow.isBefore(performanceDate)
                    }
                }
            })

            return filteredPerformances.length !== 0
        })
    }
    sortedShowtimes = _.filter(sortedShowtimes, showtimeId => {
        const filteredMovies = _.filter(moviesOrder, movieID => {
            const currentMoviePerformances = movies[movieID].performances
            const filteredPerformances = _.filter(currentMoviePerformances, performance => {
                let hasAttribute = checkForQuickTicketSelectOptions(currentMovieDate, showtimeId, currentCinema, performance, dateNow, timezone)
                const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                
                if(!_.contains(hasAttribute, 'false')) {
                    if(performance.limitations.visibleFrom) {
                        const limitationsDate = getMomentDateObj(performance.limitations.visibleFrom, timezone)
                        return dateNow.isAfter(limitationsDate)
                    } else {
                        return dateNow.isBefore(performanceDate)
                    }
                }
            })

            return filteredPerformances.length !== 0
        })

        return filteredMovies.length !== 0
    })
    
    
    sortedShowtimes.map((value) => {
        const label = value
        options.push({value,label})
    })
    
    return <Select {...selectSettings}
        options={options}
        placeholder={getTranslation('selectTime', translation)}
        value={currentMovieShowtimeOption}
        components={{ Placeholder }}
        onChange={(value) => onChange(value)}
        menuPlacement={'top'}
    />
}

export default BuyTicketMovieShowtimes